import Account from './../Resources/script.js'



export default {
    name: 'Account',
    mixins: [Account],
    data () {
        return {
            
        }
    },

    components: {
        
    },
     
    methods: {

        backTo(){
            window.history.back(); 
        },
      
    },

    created: function(){
        this.loading = true;
        let self = this;
        setTimeout(function(){ self.setSellpoint(); }, 3000); //wait for 3sec 
    }
}


// WEBPACK FOOTER //
// ./src/pages/Account/Sellpoint/script.js